import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { QRCodeSVG } from 'qrcode.react';
import {
  buildPickupQrPayload,
  formatCartIdForDisplay,
} from '../../utils/pickupQrPayload';

/**
 * Modal showing a pickup verification QR code with cart ID and customer name.
 */
export default function PickupVerificationQrModal({
  show,
  onHide,
  cartInstanceId,
  userName,
}) {
  const displayCartId = formatCartIdForDisplay(cartInstanceId);
  const displayName = (userName && String(userName).trim()) || 'User';
  const qrValue = buildPickupQrPayload({
    cartId: cartInstanceId,
    userName: displayName,
  });

  return (
    <Modal show={show} onHide={onHide} centered aria-labelledby="pickup-qr-modal-title">
      <Modal.Header closeButton>
        <Modal.Title id="pickup-qr-modal-title">Pickup Verification QR</Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center">
        <p className="text-muted small mb-3">
          Show this QR code at the supermarket so staff can verify your pickup.
        </p>
        <div
          className="d-inline-flex p-3 bg-white rounded-3 border mb-3"
          role="img"
          aria-label={`Pickup verification QR code for cart ${displayCartId}, ${displayName}`}
        >
          <QRCodeSVG
            value={qrValue}
            size={200}
            level="M"
            includeMargin={false}
            aria-hidden
          />
        </div>
        <div className="text-start mx-auto" style={{ maxWidth: '280px' }}>
          <p className="mb-1">
            <strong>Cart ID:</strong> {displayCartId || '—'}
          </p>
          <p className="mb-0">
            <strong>Name:</strong> {displayName}
          </p>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
